import packageJson from '../../package.json'

export const APP_NAME = packageJson.name
